/* eslint-disable import/prefer-default-export */
import {
  CLEAR_SEARCH_DATA,
  GET_BLOGS_SEARCH_DATA,
  GET_FORMS_SEARCH_DATA,
  GET_RESOURCE_SEARCH_DATA,
  GET_SEARCH_DATA,
  GET_TOOLBOX_SEARCH_DATA,
  SET_SEARCH_LOADER,
  SET_SEARCH_VAUE,
} from "./constants";

const initialState = {
  searchValue: "",
  searchList: {},
  loading: false,
  blogList: [],
  resourceList: [],
  toolBoxList: [],
  formList: [],
};
export const searchReducer = (state = initialState, action = { type: "", payload: "" }) => {
  switch (action.type) {
    case GET_SEARCH_DATA: {
      return {
        ...state,
        searchList: action.payload,
      };
    }
    case SET_SEARCH_LOADER: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case GET_BLOGS_SEARCH_DATA: {
      return {
        ...state,
        blogList: action.payload,
      };
    }
    case GET_RESOURCE_SEARCH_DATA: {
      return {
        ...state,
        resourceList: action.payload,
      };
    }
    case GET_TOOLBOX_SEARCH_DATA: {
      return {
        ...state,
        toolBoxList: action.payload,
      };
    }
    case GET_FORMS_SEARCH_DATA: {
      return {
        ...state,
        formList: action.payload,
      };
    }
    case SET_SEARCH_VAUE: {
      return {
        ...state,
        searchValue: action.payload,
      };
    }
    case CLEAR_SEARCH_DATA: {
      return initialState;
    }

    default:
      return state;
  }
};
